export class Membresia {
    codigoMembresia: number;
    nombre: string;
    nivel: number;
    fotografia: string;
    descripcion: string;
    porcentajeExtra: number;
    montoLimite: number;
}